import { useEffect, useState } from "react";
import "react-quill/dist/quill.snow.css"; // Import Quill styles
import { Button, Stack } from "@mui/material";
import MDBox from "components/MDBox";
import { useTranslation } from "react-i18next";
import LearningAndDevelopment from "./TrainingsPage";
import CompetencyTrainingTab from "../Competencies/myCompetencies/compTraining";
import { hasEditAccess } from "services/utils";
import { useAuth } from "context/authContext";
import { buttonStyles } from "services/utils";

// Common button styles

const TrainingsTabView = () => {
  const { t } = useTranslation();
  const [view, setView] = useState(0); //
  const { modules, employee } = useAuth();
  const [canEdit, setCanEdit] = useState(false);

  useEffect(() => {
    setCanEdit(hasEditAccess(modules, "Trainings", employee));
  }, []);

  return (
    <>
      <MDBox>
        <MDBox pb={2}>
          {/* Buttons for Switching Views */}
          <Stack
            direction={{ xs: "column", sm: "row" }} // Stacked on xs, row on sm and larger
            spacing={2} // Adds space between buttons
            alignItems="center" // Centers buttons
          >
            <Button
              sx={buttonStyles(view === 0)}
              variant={view === 0 ? "contained" : "outlined"}
              onClick={() => setView(0)}
            >
              {t("uroutes.trainings")}
            </Button>

            <Button
              sx={buttonStyles(view === 1)}
              variant={view === 1 ? "contained" : "outlined"}
              onClick={() => setView(1)}
            >
              {t("admin.competency.competencyTraining")}
            </Button>
          </Stack>
        </MDBox>
      </MDBox>

      {view === 0 ? (
        <LearningAndDevelopment canEdit={canEdit} />
      ) : (
        <CompetencyTrainingTab canEdit={canEdit} />
      )}
    </>
  );
};

export default TrainingsTabView;
